const createCSSGradient = (gradient, angle) => {
  const gradientStops = gradient.map(({
    color,
    offset
  }) => `${color} ${offset}%`);
  return `linear-gradient(${angle}deg, ${gradientStops.join(',')})`;
};

export { createCSSGradient };
